import { render, staticRenderFns } from "./AppUpdateModal.vue?vue&type=template&id=edf25d4c&scoped=true&"
import script from "./AppUpdateModal.vue?vue&type=script&lang=js&"
export * from "./AppUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdateModal.vue?vue&type=style&index=0&id=edf25d4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf25d4c",
  null
  
)

export default component.exports